import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UpdateOrganization } from '../../graphql/organization';
// import editDemographics from './editDemographics';
import { requestUserByEmail } from '../../graphql/users';
import { createUser } from '../../graphql/updateUsers';



export default function AddOrganizationHOC(AddOrganizationPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
      }).isRequired,
      initialValues: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        cageCode: PropTypes.string,
        address1: PropTypes.string,
        address2: PropTypes.string,
        address3: PropTypes.string,
        zipCode: PropTypes.string,
        cntry: PropTypes.string,
        pointofContact: PropTypes.string,
        phoneNumber: PropTypes.string,
        organizationType: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        websiteUrl: PropTypes.string,
      }).isRequired,
      // onCountryChange: PropTypes.func.isRequired,
      alertType: PropTypes.string.isRequired,
      alertMessage: PropTypes.string.isRequired,
      refreshDemoInitialValues: PropTypes.func.isRequired,
    };

    static initialState = {
      isLoading: true,
      errors: [],
      alertType: '',
      alertMessage: '',
      formValues: {
        id: "",
        name: "",
        cageCode: "",
        address1: "",
        address2: "",
        address3: "",
        zipCode: "",
        cntry: "USA",
        pointofContact: "",
        phoneNumber: "",
        organizationType: "",
        city: "",
        state: "",
        websiteUrl: "",
      }
    }

    state = WrappedComponent.initialState;
    async componentDidMount() {
      this.setState({
        formValues: this.props.initialValues,
      });
    }

    onResetForm = () => {
      this.setState({
        formValues: this.props.initialValues,
      });
    }

    _onSubmit = async formData => {
      console.log("formData", formData)
      // const { organizationId } = this.props;
      const payload = {
        ...formData,
        // organizationId,
      };
      const { userByEmail } = await requestUserByEmail(formData.email);
      let userInfo = {
        name: formData.pointOfContact,
        // email: formData.email,
        phoneNumber: formData.phoneNumber,
        organizationId: formData.id,
        role: 'admin',
        iconStatus: formData.iconStatus,
        cageCode: formData.cageCode,
      };
      if (userByEmail) {
        userInfo = {
          ...userInfo,
          id: userByEmail.id,
          auth0Id: userByEmail.auth0Id,
          email: userByEmail.email
        };
      }
      console.log(userInfo)
      try {
        await UpdateOrganization(payload);
        // If userByEmail this UPDATES a user in BOTH Auth0 and DynamoDB, if no email then CREATES a user in BOTH Auth0 and DynamoDB
        await createUser(userInfo);
        this.setState({
          alertType: 'success',
          alertMessage: 'Successfully updated!',
        });
        // reinitialize the form
        this.props.refreshDemoInitialValues();
      } catch (error) {
        console.error(error);
        this.setState({
          alertType: 'warning',
          alertMessage:
            'There was a problem during submission, please try again in a few minutes',
        });
      }
    };

    onCountryChange = (value) => {
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          cntry: value,
          state: null,
        }
      }))
    }

    onStateProvChange = (value) => {
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          state: value,
        }
      }))
    }

    onFieldChange = (name, value) => {
      console.log(" field change", name, value)
      if (name === "cntry" || name === "state") {
        return
      }
      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          [name]: value,
        }
      }))
    }

    render() {
      // const {  } = this.state;

      const { formValues, isLoading, errors, alertType, alertMessage } = this.state;
      // Configure Page
      const pageProps = {
        initialValues: formValues,
        onCountryChange: this.onCountryChange,
        onStateProvChange: this.onStateProvChange,
        onFieldChange: this.onFieldChange,
        isLoading,
        onSubmit: this._onSubmit,
        onResetForm: this.onResetForm,
        errors,
        alertType,
        alertMessage,
      };

      return <AddOrganizationPage {...pageProps} />;
    }
  }

  return WrappedComponent;
}



// WEBPACK FOOTER //
// ./src/components/EditDemographics/editDemographicsHOC.jsx